export const magmaCategoricalDefault: string[] = [];
export const magmaCategoricalMixed: string[] = [];
